export default "__VITE_ASSET__CO$0NCeZ__"